module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"sds-text-2":"Velan tila","sds-text-3":"Alkuperäinen velkoja","sds-text-4":"Yksipuolinen tuomio tiedoksiannettu"},"se":{"sds-text-2":"Skuld status","sds-text-3":"Ursprunglig fordringsägare","sds-text-4":"Tredskodom har delgivits"},"en":{"sds-text-2":"Debt status","sds-text-3":"Original creditor","sds-text-4":"Judgement by default has been served"}}')
  delete Component.options._Ctor
}
